import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import axios from 'axios';

const i18nInstance = i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'ms'],
    preload: ['en', 'ms'],
    ns: ['translation'],
    defaultNS: 'translation',
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      addPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator', 'querystring', 'cookie'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
    },
    react: {
      useSuspense: false
    },
  });

// Function to get user's country from IP and set language
export const detectCountryFromIP = async () => {
  // Only detect country if language is not already set
  if (!localStorage.getItem('i18nextLng')) {
    try {
      const response = await axios.get('https://ipapi.co/json/');
      const country = response.data.country;
      
      // Set language based on country
      if (country === 'MY') {
        await i18n.changeLanguage('ms');
      } else {
        await i18n.changeLanguage('en');
      }
    } catch (error) {
      console.error('Error detecting country:', error);
      // Default to English on error
      await i18n.changeLanguage('en');
    }
  }
};

// Wait for translations to be loaded
export const initializeI18n = async () => {
  await i18nInstance;
  return i18n;
};

export default i18n;
